export const SUPPORT_EMAIL = 'info@chpokify.com';

export const CONTACT_TEL = '+35796693348';
